<template>
    <div v-if="loaded" :class="topClass">
        <v-row class="ma-0 pt-0">
            <v-col v-for="(info, i) in infosLoaded" class="pa-0 pb-4" :class="setClass(i)" :key="i">
                <show-generator
                    :model-key="i"
                    :info="info"
                    :model="modelsLoaded[i]"
                    :field-class="fieldClass[i]"
                    :no-buttons="noButtons"
                    :model-length="getModelsLength()"
                    :model-number="getModelsNumber(i)"
                    :entity-title="entityTitle"
                    :parent-model-class="resolvedModelClass"
                    :model-def="modelDef"
                ></show-generator>
            </v-col>
        </v-row>

        <slot name="relations">
            <v-row class="ma-0" v-for="(relation, i) in relationsLoaded" :key="i">
                <belongstomany-show
                    class="pb-4"
                    :parent="modelsLoaded[modelClass]"
                    :collection="relation.collection"
                    :headers="relation.info.fieldDefs"
                    :title="relation.info.crudRelation.title"
                    :filter="relation.info.crudRelation.filter"
                    :downloadCSV="typeof relation.info.crudRelation.downloadCSV != 'undefined' ? relation.info.crudRelation.downloadCSV : true">
                    <template v-slot:table-footer v-if="relation.info.footer">
                        <component
                            :is="relation.info.footer"
                            :items="relation.collection"
                            :fieldsset="relation.info.fieldDefs"
                            :parent="modelsLoaded[modelClass]"
                            :relations-loaded="relationsLoaded"
                            :totals-fields="getTotalsFields()"
                            :totals-hidden="getTotalsHidden()"
                            type="show"
                        ></component>
                    </template>
                </belongstomany-show>
            </v-row>
        </slot>

        <!-- scadenze subito sotto le righe del documento, prima del registro -->
        <document-deadlines-table v-if="deadlines && modelClass != '' && modelsLoaded[modelClass]"
            class="pb-4"
            :document-type="modelClass"
            :document-id="id"
            :model="modelsLoaded[modelClass]"
        ></document-deadlines-table>

        <activities v-if="activities && modelClass != ''"
            class="pb-4"
            :model-class="activitiesModelClass"
            :model-id="activitiesModelId"
            :model-def="modelDef"
            :note-field="noteField"
            :model="modelsLoaded[modelClass]"
        ></activities>

        <!-- PDF Preview Section -->
        <v-card v-if="pdfPreviewUrl" class="pb-4 mb-4 round-card background-2">
            <v-card-title>
                <p class="pl-2 pl-xl-3">Anteprima PDF</p>
                <v-spacer></v-spacer>
                <v-tooltip top>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn 
                            icon 
                            @click="downloadPdf()" 
                            v-if="pdfData"
                            v-on="{ ...tooltip }">
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                    </template>
                    <span>Scarica PDF</span>
                </v-tooltip>
            </v-card-title>
            <v-divider></v-divider>
            
            <v-card-text>
                <v-progress-circular v-if="!pdfData" indeterminate color="primary" class="ma-5"></v-progress-circular>
                <object 
                    v-else 
                    style="width:100%; height: 1200px;" 
                    :data="pdfData" 
                    type="application/pdf"
                    title="Documento PDF"
                    name="Documento">
                </object>
            </v-card-text>
        </v-card>        

        <entity-calendar-events v-if="calendarEvents && modelClass != '' && $store.getters.checkModulePermissions('calendar')"
            class="pb-4"
            :model-class="modelClass"
            :model-id="id"
        ></entity-calendar-events>

        <edocument-notifications v-if="edocuments && modelClass != '' && $store.getters.getSetting('e_invoice')"
            class="pb-4"
            :model-class="modelClass"
            :model-id="id"
        ></edocument-notifications>

        <mail-logs v-if="maillogs && modelClass != ''"
            class="pb-4"
            :card-class="['elevation-0 py-0']"
            :quick-send="false"
            :model-class="modelClass"
            :model-id="id"
        ></mail-logs>

        <v-col class="pa-0" v-if="fileuploader && modelClass != ''">
            <dms-uploader
                :id="id"
                :attachable-type="modelClass"
            ></dms-uploader>
        </v-col>

        <!-- Assegnazione foto→varianti: nessuna UI propria, serve il menu contestuale
             del File Storage (prop-gated come le altre feature entity-specific). -->
        <product-photo-assignment v-if="photoAssignment && id" :id="id"></product-photo-assignment>

        <v-tooltip top v-if="!noEdit && modelDef != ''">
            <template v-slot:activator="{ on: tooltip }">
                <v-fab-transition>
                    <v-btn
                        v-on="{ ...tooltip }"
                        @click.native="$eventBusUtility.goTo($router, routeEdit, id, null, redirect ? redirect.params : {})"
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab>
                        <v-icon>edit</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Modifica</span>
        </v-tooltip>
        
    </div>
</template>

<script>
    import { getGroupKey } from '@/router/breadcrumbRegistry'
    import MailLogs from '@/components/common/MailLogs'
    import Activities from '@/components/common/Activities'
    import ShowGenerator from '@/components/common/ShowGenerator'
    import BelongstomanyShow from '@/components/common/BelongstomanyShow'
    import FooterProductDocumentTable from '@/components/common/FooterProductDocumentTable'
    import EntityCalendarEvents from '@/components/common/EntityCalendarEvents'
    import EdocumentNotifications from '@/components/modules/invoices/EdocumentNotifications'
    import FooterProductPurchaseddtTable from '@/components/modules/ddts/FooterProductPurchaseddtTable'
    import ProductPhotoAssignment from '@/components/modules/products/ProductPhotoAssignment'
    import DocumentDeadlinesTable from '@/components/modules/invoices/deadlines/DocumentDeadlinesTable'

    export default {
        name: 'show',
        components: {
            MailLogs,
            Activities,
            ShowGenerator,
            BelongstomanyShow,
            EntityCalendarEvents,
            EdocumentNotifications,
            FooterProductDocumentTable,
            FooterProductPurchaseddtTable,
            ProductPhotoAssignment,
            DocumentDeadlinesTable,
        },
        props: {
            topClass: {
                type: String,
                default: 'pb-offset'
            },
            id: Number,
            models: {
                type: Object,
                default: () => {}
            },
            infos: {
                type: Object,
                default: () => {}
            },
            relations: {
                type: Object,
                default: () => {}
            },
            redirect: {
                type: Object,
                default: () => {}
            },
            modelDef: {
                type: String,
                default: ''
            },
            modelClass: {
                type: String,
                default: ''
            },
            noButtons: {
                type: Boolean,
                default: false
            },
            noEdit: {
                type: Boolean,
                default: false
            },
            activities: {
                type: Boolean,
                default: false
            },
            edocuments: {
                type: Boolean,
                default: false
            },
            deadlines: {
                type: Boolean,
                default: false
            },
            maillogs: {
                type: Boolean,
                default: false
            },
            fileuploader: {
                type: Boolean,
                default: false
            },
            photoAssignment: {
                type: Boolean,
                default: false
            },
            calendarEvents: {
                type: Boolean,
                default: false
            },
            pdfPreviewUrl: {
                type: String,
                default: ''
            },
            entityTitle: {
                type: String,
                default: ''
            },
            noteField: {
                type: String,
                default: ''
            }
        },
        
        data() {
            return {
                cardClass: '',
                fieldClass: {},
                modelsLoaded: {},
                infosLoaded: {},
                relationsLoaded: {},
                loaded: false,
                pdfData: null,
                pdfBlob: null
            }
        },

        mounted() {
			this.$eventBusUtility.$on('refreshShow', () => {
                this.modelsLoaded = {}
                this.infosLoaded = {}
                this.relationsLoaded = {}
                this.initialization()
				})
            if (this.pdfPreviewUrl) {
                this.getPdfData();
            }
        },

        created() {
            this.initialization()
        },

        computed: {
            routeEdit() {
                if(typeof this.redirect !== 'undefined') {
                    return this.redirect.modelDef + '-edit'
                }
                return this.modelDef + '-edit'
            },
            resolvedModelClass() {
                if (this.modelClass) return this.modelClass
                if (this.modelDef) return this.modelDef.replace(/s$/, '')
                return ''
            },

            linkedBusinessMorphClass() {
                const b = this.modelsLoaded && this.modelsLoaded.business
                if (!b) return null
                switch (Number(b.business)) {
                    case 0: return 'company'
                    case 1: return 'supplier'
                    case 2: return 'lead'
                    case 3: return 'prospect'
                    default: return null
                }
            },

            activitiesRedirectActive() {
                if (!this.modelDef) return false
                const setting = this.$store.getters.getSettingByModel(this.modelDef, 'activities_from_linked_business')
                if (setting !== true && setting !== 'true' && setting !== 1 && setting !== '1') return false
                return !!this.linkedBusinessMorphClass && !!(this.modelsLoaded.business && this.modelsLoaded.business.id)
            },

            activitiesModelClass() {
                return this.activitiesRedirectActive ? this.linkedBusinessMorphClass : this.modelClass
            },

            activitiesModelId() {
                return this.activitiesRedirectActive ? this.modelsLoaded.business.id : this.id
            }
        },

        methods: {

            getTotalsFields() {
                if (this.modelClass && this.infosLoaded[this.modelClass] && this.infosLoaded[this.modelClass].totals_config) {
                    return this.infosLoaded[this.modelClass].totals_config.fields || null
                }
                return null
            },

            getTotalsHidden() {
                if (this.modelClass && this.infosLoaded[this.modelClass] && this.infosLoaded[this.modelClass].totals_config) {
                    return this.infosLoaded[this.modelClass].totals_config.hidden || false
                }
                return false
            },

            initialization() {
                if(this.modelDef != '' && !this.infos && !this.models) {
                    this.axios.get(this.modelDef + '/' + this.id).then(response => {
                        this.modelsLoaded = response.data.models
                        this.infosLoaded = response.data.infos
                        this.relationsLoaded = response.data.relations
                        this.loaded = true
                        this.$store.commit('endProgress')
                        this.emitBreadcrumbLabel()

                    }, response => {
                        // error callback
                    })
                } else {
                    this.modelsLoaded = this.models
                    this.infosLoaded = this.infos
                    this.relationsLoaded = this.relations
                    this.loaded = true
                    this.$store.commit('endProgress')
                    this.emitBreadcrumbLabel()
                }

                // Check for only mobile models
                for(var index in this.infosLoaded) {
                    if(typeof this.infosLoaded[index].onlyMobile !== 'undefined' && this.infosLoaded[index].onlyMobile && !this.$vuetify.breakpoint.smAndDown) {
                        delete this.infosLoaded[index]
                        delete this.modelsLoaded[index]
                    }
                }

                // Omit panels whose model is null (es. lotto matricola senza fornitore):
                // ShowGenerator assume model.id sempre presente, quindi il pannello va
                // rimosso invece di renderizzato vuoto.
                for(var key in this.infosLoaded) {
                    if(this.modelsLoaded[key] === null || typeof this.modelsLoaded[key] === 'undefined') {
                        delete this.infosLoaded[key]
                        delete this.modelsLoaded[key]
                    }
                }
            },

            // Espone al breadcrumb il titolo umano del record (per le show senza
            // wrapper XxxTabs con entityTitle, es. preventivi)
            emitBreadcrumbLabel() {
                const firstKey = Object.keys(this.infosLoaded || {})[0]
                const model = firstKey ? this.modelsLoaded[firstKey] : null
                if (!model) {
                    return
                }
                const label = ['entity_title', 'title', 'business_name', 'name', 'subject']
                    .map(field => model[field])
                    .find(value => typeof value === 'string' && value.trim() !== '')
                if (!label) {
                    return
                }
                // solo se questa show rappresenta l'entità della route corrente
                const groupKey = getGroupKey(this.$route)
                if (!groupKey.endsWith('/' + this.id)) {
                    return
                }
                this.$store.commit('setCrumbEntityLabel', { groupKey, label: label.trim() })
            },

            getModelsNumber(i) {
                return Object.keys(this.infosLoaded).indexOf(i)
            },

            getModelsLength() {
                return _.size(this.infosLoaded)
            },

            setClass(i) {
                let index = Object.keys(this.infosLoaded).indexOf(i)
                let padding = ''
                if(_.size(this.infosLoaded) % 2 === 0) {
                    if(index % 2 === 0) {
                        if(this.$vuetify.breakpoint.xs) {
                            this.fieldClass[i] = 'col-12 col-sm-6 col-md-4'
                        }
                        this.fieldClass[i] = 'col-lg-4 col-sm-6 col-md-4 col-12'
                        if(this.$vuetify.breakpoint.lgAndUp) {
                            padding = 'pr-2'
                        }
                    } else {
                        if(this.$vuetify.breakpoint.xs) {
                            this.fieldClass[i] = 'col-12 col-sm-6 col-md-4'
                        }
                        if(this.$vuetify.breakpoint.lgAndUp) {
                            padding = 'pl-2'
                        }
                        this.fieldClass[i] = 'col-lg-4 col-sm-6 col-12 col-md-4'
                    }
                    return 'col-lg-6 col-12 ' + padding
                } else if(_.size(this.infosLoaded) % 2 !== 0) {
                    if(index === 0) {
                        this.fieldClass[i] = 'col-lg-3 col-sm-6 col-12'
                        return 'col-12 '
                    } else {
                        if(this.$vuetify.breakpoint.xs) {
                            this.fieldClass[i] = 'col-12 col-sm-6'
                            return 'col-lg-6 col-12 pt-4'
                        }
                        this.fieldClass[i] = 'col-lg-4 col-12 col-sm-6'
                        if(this.$vuetify.breakpoint.lgAndUp) {
                            if(index % 2 === 0) {
                                padding = 'pl-2'
                            } else {
                                padding = 'pr-2'
                            }
                        }
                        return 'col-lg-6 col-12 ' + padding
                    }
                }
            },

            async getPdfData() {
                if (this.pdfData != null) {
                    return this.pdfData
                }

                let options = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'Authorization': 'Bearer ' + this.$store.getters.token
                    },
                    method: 'GET'
                }
                try {
                    const response = await fetch(this.$store.getters.baseUrl + '/api/' + this.pdfPreviewUrl + '/' + this.id + '/print', options)
                    const blob = await response.blob()
                    // It is necessary to create a new blob object with mime-type explicitly set
                    // otherwise only Chrome works like it should
                    const newBlob = new Blob([blob], {type: blob.type})

                    // Salva il blob per il download
                    this.pdfBlob = newBlob
                    this.pdfData = window.URL.createObjectURL(newBlob)
                    return this.pdfData
                } catch (error) {
                    console.error('Error fetching PDF:', error)
                }
            },

            downloadPdf() {
                if (this.pdfBlob) {
                    const link = document.createElement('a')
                    const url = window.URL.createObjectURL(this.pdfBlob)
                    link.href = url
                    link.setAttribute("target", "_blank")
                    // Nome file basato sul modello se disponibile
                    const filename = this.modelsLoaded[this.modelClass]?.sdi_filename
                        ? this.modelsLoaded[this.modelClass].sdi_filename + '.pdf'
                        : 'Documento.pdf'
                    link.download = filename
                    link.click()
                    // Revoca l'URL solo dopo il click
                    setTimeout(() => {
                        window.URL.revokeObjectURL(url)
                    }, 100)
                }
            }
        },

        beforeDestroy() {
			this.$eventBusUtility.$off('refreshShow')
            // Cleanup ObjectURL quando il componente viene distrutto
            if (this.pdfData) {
                window.URL.revokeObjectURL(this.pdfData)
            }
        }

    }
</script>